<template>
  <section class="company-page">
    <company-header :h1Content="h1Content" />
    <company-info :introContent="introContent" />
    <company-buttons :products="products" />
    <app-question-panel
      class="mt-16"
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :questions="questions"
    />
  </section>
</template>

<script>
import companyHeader from '@/component/company/CompanyHeader'
import companyInfo from '@/component/company/CompanyInfo'
import appQuestionPanel from '@/component/expansional-question-panel/AppQuestionPanel'
import companyButtons from '@/component/company/CompanyButtons'

export default {
  metaInfo: {
    title: 'Mapfre Sigorta Fiyatları İçin Teklif Alın, Karşılaştırın',
    meta: [
      {
        name: 'description',
        content:
          "Mapfre Sigorta'dan fiyat teklifi alarak karşılaştırma yapın, en iyi sigorta planlarına online ulaşın. Mapfre Sigorta Güvencesi ile poliçenizi satın alın."
      }
    ]
  },
  name: 'MapfreSigorta',
  components: {
    companyHeader,
    companyInfo,
    appQuestionPanel,
    companyButtons
  },
  data () {
    return {
      h1Content: 'Mapfre Sigorta Fiyatları',
      faqTitle: 'Mapfre Sigorta Hakkında Merak Edilen Sorular',
      faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
      products: {
        title: 'Mapfre Sigorta Ürünleri',
        buttons: [
          {
            id: 1,
            title: 'TRAFİK SİGORTASI',
            class: 'company--btn--icons fas fa-car fa-2x mr-2',
            path: 'MapfreSigortaCompulsoryTraffic'
          },
          {
            id: 2,
            title: 'KASKO SİGORTASI',
            class: 'company--btn--icons fas fa-car-crash fa-2x mr-2',
            path: 'MapfreSigortaMotorInsurance'
          },
          {
            id: 3,
            title: 'DASK SİGORTA',
            class: 'company--btn--icons fas fa-laptop-house fa-2x mr-2',
            path: 'MapfreSigortaDaskInsurance'
          },
          {
            id: 4,
            title: 'KONUT SİGORTASI',
            class: 'company--btn--icons fas fa-house-damage fa-2x mr-2',
            path: 'MapfreSigortaHomeInsurance'
          },
          {
            id: 5,
            title: 'İŞYERİ SİGORTASI',
            class: 'company--btn--icons fas fa-building  fa-2x mr-2',
            path: 'MapfreSigortaCompanyInsurance'
          },
          {
            id: 6,
            title: 'FERDİ KAZA SİGORTASI',
            class: 'company--btn--icons fas fa-user-injured fa-2x mr-2',
            path: 'MapfreSigortaPersonalAccident'
          },
          {
            id: 7,
            title: 'NAKLİYAT SİGORTASI',
            class: 'company--btn--icons fas fa-luggage-cart fa-2x mr-2',
            path: 'MapfreSigortaTransportation'
          },
          {
            id: 8,
            title: 'ÖZEL SAĞLIK SİGORTASI',
            class: 'company--btn--icons fas fa-heartbeat fa-2x mr-2',
            path: 'MapfreSigortHealthInsurance'
          },

          {
            id: 9,
            title: 'TAMAMLAYICI SAĞLIK SİGORTASI',
            class: 'company--btn--icons fas fa-briefcase-medical fa-2x mr-2',
            path: 'MapfreSigortaComplementaryHealth'
          },
          {
            id: 10,
            title: 'SEYAHAT SAĞLIK SİGORTASI',
            class: 'company--btn--icons fas fa-umbrella-beach fa-2x mr-2',
            path: 'MapfreSigortaTravelInsurance'
          }
        ]
      },
      introContent: {
        title: 'Mapfre Sigorta Hakkında',
        content: [
          {
            paragraph:
              'Mapfre Sigorta, Türkiye Kredi Bankası A.Ş. ve diğer girişimciler ile T. Genel Sigorta olarak, 1975 yılında Çukurova Holding iştiraklerine katılmıştır.'
          },
          {
            paragraph:
              '2007’de, İspanya ve Güney Amerika’nın en güçlü grubu Mapfre, Çukurova Holding’in hisselerinin %80’ini alıp hâkim ortağı olması sonucunda 2009 yılında Mapfre Genel Sigorta, 2016 yılında ise Mapfre Sigorta olarak, hizmet vermeye devam etmiştir.'
          },
          {
            paragraph:
              'Günümüz itibari ile MAPFRE INTERNACIONAL ‘ın Mapfre Sigortadaki payı %97,74 ‘dür. '
          },
          {
            paragraph:
              'Sigorta şirketi prensibi, sigortacılığın legal değerlerine sadık kalarak, sigortalı ve poliçe işlemlerini yapan acentelerinin talep ve yönlendirmelerini önemseyerek, hizmet kalitesinden ödün vermeden, oluşabilecek tüm riskleri belirleyip, en cazip ücretlendirmeyi yaparak müşterilerine geniş kapsamlı hizmet vermektedir.'
          },
          {
            paragraph:
              'Mapfre Sigorta’nın Başlıca Reasürörleri: MAPFRE RE - MUNICH RE - SWISS RE - MILLI RE - VHV RE - HANNOVER RE.'
          },
          {
            paragraph:
              'Genel Müdürlüğü İstanbul olan Mapfre Sigorta’nın 14 Bölge Müdürlüğü ve 5 Şubesi bulunmaktadır.'
          }
        ]
      },
      questions: [
        {
          title: 'Mapfre Sigorta Ürün Çeşitleri Nelerdir?',
          content: [
            {
              paragraph:
                'Mapfre Sigorta ürün paketlerinden yararlanmak isteyen müşterilerimiz <strong><em><u>alokasko.com</u></em></strong> sayfamızdan en detaylı teklif ihtiyaçlarına kolayca ulaşabilir. ',
              subList: null
            },
            {
              paragraph:
                'Mapfre Sigorta Alokasko’nun anlaşmalı olduğu sigorta şirketlerindendir. Şirketimiz kapsamında size özel teklif hazırlayabileceğimiz sigorta paketlerinden bazıları aşağıdaki gibidir;',
              subList: [
                'Trafik Sigortası',
                'Araç Kasko Sigortası',
                'DASK (Zorunlu Deprem Sigortası)',
                'Konut Sigortası',
                'İşyeri Sigortası',
                'Ferdi Kaza Sigortası',
                'Nakliyat Sigortası',
                'Özel Sağlık Sigortası',
                'Tamamlayıcı Sağlık Sigortası',
                'Seyahat Sağlık Sigortası '
              ]
            },
            {
              paragraph:
                'Mapfre Sigorta’nın hizmet verdiği tüm sigorta ürünlerinden ihtiyaç duyduğunuz ürünler için sigorta uzmanlarımızdan fiyat teklifi isteyebilirsiniz. ',
              subList: null
            }
          ]
        },
        {
          title: 'Mapfre Sigorta Zorunlu Trafik Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Mapfre Sigorta trafik sigortası paketi, motorlu aracın kullanılması sırasında üçüncü kişilerin ölümü, yaralaması veya bir varlığın zarar görmesine sebebiyet vermesinden dolayı meydana gelebilecek zararlar Karayolları Trafik Kanununa göre, kullanıcı için belirlenen zorunlu trafik sigortası limitleri kadarını karşılanır. ',
              subList: null
            },
            {
              paragraph:
                '2021 yılında Devlet Hazine Müsteşarlığı tarafından belirlenen trafik sigortası limitleri;',
              subList: [
                'Araç Başı Maddi Tazminat: 43.000 TL',
                'Kaza Başı Maddi Tazminat: 86.000 TL',
                'Kişi Başı Sağlık Giderleri Tazminatı: 430.000 TL',
                'Kaza Başı Sağlık Giderleri Tazminatı: 2.150.000 TL',
                'Kişi Başı Sakatlanma ve Ölüm Tazminatı: 430.000 TL',
                'Kaza Başı Sakatlanma ve Ölüm Tazminatı: 2.150.000 TL'
              ]
            },
            {
              paragraph:
                'Mapfre Trafik Sigortası İsteğe Bağlı Yol Yardım Hizmetleri: ',
              subList: [
                'Aracın Çekilmesi',
                'Aracın Kurtarılması',
                'Araç Kazası Sonucu Yaralanma Durumunda Nakil',
                'Yol Yardım Hizmetleri'
              ]
            },
            {
              paragraph:
                'Aracınızın trafik sigortası tekliflerini <strong><em><u>alokasko.com</u></em></strong> sigorta danışmanlarından en uygun ve avantajlı şekilde talep edebilirsiniz',
              subList: null
            }
          ]
        },
        {
          title: 'Mapfre Sigorta Araç Kasko Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Mapfre Sigorta Kasko Sigortası kapsamında araç sürücülerine sunulan geniş kapsamlı teminatların yanı sıra yol yardım hizmetleri ile kasko sigortası öne çıkmaktadır. Araç kasko sigortası, sigortalı aracı güvence altına alarak, araç sürücüsünün bütçesini korur.',
              subList: null
            },
            {
              paragraph: '<strong>Mapfre Kasko Ana Teminat Kapsamı: </strong>',
              subList: [
                'Sigortalı aracın motorlu araçla çarpışması sonucunda meydana gelen hasarlar.',
                'Üçüncü kişilerin kaskolu araca vereceği kötü niyetli zararlar.',
                'Kemirgen hayvanların sigortalı araca vereceği hasarlar.',
                'Aracın yanması sonucu meydana gelen hasar ve zararlar.',
                'Hususi araçlar ve 4 kişilik oturma yeri olan kamyonetler için ikame araç (Onarımın 48 saati geçme şart ile).',
                'Sıfır yaş araçlar için değer kaybı.',
                'Aracın çalınması ya da çalınmaya teşebbüs edilmesi.',
                'Sel ve su baskını sebebiyle oluşan hasarlar.',
                'Grev, kargaşalık, lokavt, halk hareketleri ve terör sonucunda oluşacak hasarlar.',
                'Araçta sigara ve benzeri maddelerin sebep olacağı hasarlar dışındaki yangın durumları.'
              ]
            },
            {
              paragraph:
                '<strong>İsteğe Bağlı Poliçeye Eklenebilen Teminatlar:</strong>',
              subList: [
                'Deprem, fırtına, dolu zararları',
                'Araç anahtarının kaybı',
                'Araç anahtarının gasp veya çalınması suretiyle oluşan zararlar',
                'Otopark ve valeye bir belge ile teslim edilen araçların çalınması',
                'Konut ve Oto Adaptasyon Teminatı',
                'Mini Onarım Teminatı',
                'Özel Eşya Teminatı',
                'Koltuk Ferdi Kaza Teminatı',
                'Artan Mali Mesuliyet Teminatı',
                'Hukuksal Koruma Teminatı.'
              ]
            },
            {
              paragraph:
                'Mapfre Kasko Sigortası avantajlarından faydalanmak için teklif almanız yeterlidir.',
              subList: null
            }
          ]
        },
        {
          title: 'Mapfre Sigorta DASK – Zorunlu Deprem Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Depremden kaynaklanan maddi zararlar ve deprem sonucunda oluşan;',
              subList: [
                'İnfilak,',
                'Yangın,',
                'Yer Kayması,',
                'Sel-Su Baskını,',
                'Tsunami sonucunda evinize gelen hasarlar DASK poliçesi ile güvence altındadır.'
              ]
            },
            {
              paragraph: '<strong><em><u>DASK Primler;</u></em></strong>',
              subList: [
                'Konutların Yapı Tarzı,',
                'Deprem Risk Bölgesi,',
                'Binanızın Yaşı, ',
                'Kullanım Tarzı, ',
                'Konutun Net Metrekare Ölçüsü ile belirlenmektedir.'
              ]
            },
            {
              paragraph:
                'Diğer zorunlu sigortalarda da olduğu gibi, Zorunlu Deprem Sigortasında da her yenilemenizde, vade boşluğu olmaması durumunda yenileme indirimlerinden faydalanabilirsiniz. Yaşanan hasar sonrasında alacağınız ödeme, her sene devlet tarafından metrekare başına ödenecek tutarın belirlenmesi ile değişir. ',
              subList: null
            },
            {
              paragraph:
                'Doğal afetlere karşı evinizi teminat altına almak için <strong><em><u>alokasko.com</u></em></strong> uzmanları her zaman destek için hazır. ',
              subList: null
            }
          ]
        },
        {
          title: 'Mapfre Sigorta Konut Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Mapfre Sigorta Konut Sigortasında evinizi ve eşyalarınızı, konutunuzun yer aldığı binanın alabileceği hasarları teminat altına almaktadır. ',
              subList: null
            },
            {
              paragraph:
                'Konut sigortasının yapılabilmesi için ev sahibi ya da kiracı olunması gibi bir ayırımlar yoktur. ',
              subList: null
            },
            {
              paragraph:
                'Konutunuzda yaşanan her hasarda zararınızı karşılatmak istiyorsanız sunulan teminatları detaylı incelemeli ve doğru teminat gruplarını satın almaya özen göstermelisiniz.',
              subList: null
            },
            {
              paragraph:
                '<strong><em><u>Konut Sigortası Hesaplamalarında;</u></em></strong>',
              subList: [
                'Bina Yaşı,',
                'Yapı Tarzı, ',
                'Konutun Kaçıncı Katta Olduğu, ',
                'Binanın Toplam Kat Sayısı,',
                'Yüz Ölçümü, ',
                'Dış Cephe Tarzı etkilidir.'
              ]
            },
            {
              paragraph:
                'Hasar durumunda faydalanacağınız tazminat tutarı poliçe kapsamına alınan limitler dahilinde belirlenecektir. Konut Sigorta primlerini öğrenmek için teklif alabilirsiniz.',
              subList: null
            }
          ]
        },
        {
          title: 'Mapfre Sigorta İşyeri Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Mapfre Sigorta’nın uluslararası hazırlamış olduğu “Ticari Paket Sigortası” hem çalışanlarınızı hem işyerindeki makineleri hem de elektronik cihazları güvence altına alır.',
              subList: null
            },
            {
              paragraph: 'Mapfre Ticari Paket Ana Teminatları: ',
              subList: [
                'Dahili Su Teminatı',
                'Duman Teminatı',
                'Enkaz Kaldırma Masrafları',
                'Fırtına Teminatı',
                'Kar Ağırlığı Teminatı',
                'Taşıt Çarpması Teminatı',
                'Yakıt Sızması Teminatı',
                'Yangın, Yıldırım, İnfilak Teminatı',
                'Yer Kayması Teminatı.'
              ]
            },
            {
              paragraph:
                '**Bunun dışında işyeri sigortası kapsamını genişletmek isterseniz değerlendirebileceğiniz birçok ek teminat grubu vardır.',
              subList: null
            },
            {
              paragraph:
                'İşyerinizi güvence altına almak için <strong><em><u>alokasko.com</u></em></strong> uzmanlarından teklif alabilirisiniz.',
              subList: null
            }
          ]
        },
        {
          title: 'Mapfre Sigorta Ferdi Kaza Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Mapfre Ferdi Kaza Sigortası sizi ve sevdiklerinizi hayatın kötü sürprizlerine karşı güvence altına alır. Oluşabilecek risk durumlarını poliçe kapsamına ekler ve yarınlarınıza teminat sunar.',
              subList: null
            },
            {
              paragraph:
                '<strong><em><u>Mapfre Ferdi Kaza Sigortası Ana Teminatları:</u></em></strong>',
              subList: [
                'Kaza Sonucu Vefat Teminatı',
                'Kaza Sonucu Sürekli Sakatlık Teminatı.'
              ]
            },
            {
              paragraph:
                '<strong><em><u>Mapfre Ferdi Kaza Sigortası Ek Teminatları:</u></em></strong>',
              subList: [
                'Kaza Sonucu Tedavi Masrafları',
                'Gündelik Tazminat Talepleri',
                'Deprem, Sel, Yanardağ Püskürmesi ve Yer Kayması Teminatı.'
              ]
            },
            {
              paragraph:
                'Beklenmeyen durumlara karşı hayatınızı ve sevdiklerinizi Mapfre Sigorta güvencesiyle koruyun!',
              subList: null
            }
          ]
        },
        {
          title: 'Mapfre Sigorta Nakliyat Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Mapfre Nakliyat Emtea Sigortası ile yüklerinizde güvence altında.',
              subList: null
            },
            {
              paragraph:
                'Büyük yük taşımacılığı yapan kişilerin sorumlulukları da fazladır. Ürünlerin hem zamanında hem de sorunsuz teslim yapması gerekir. Yüklerin taşınma sırasında meydana gelebilecek zararlar Mapfre Nakliyat Sigortası ile teminat altına alınır.',
              subList: null
            },
            {
              paragraph:
                'Denizyolu, karayolu, havayolu ve demiryolu taşımacılığı yapanların yararlanabileceği nakliyat sigortası ile nakil durumlarındaki hasar ve zararlar karşılanır.',
              subList: null
            }
          ]
        },
        {
          title: 'Mapfre Sigorta Özel Sağlık Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Mapfre Özel Sağlık Sigortası kapsamında hazırlanan “<strong><em><u>3S Sağlık Sistemi</u></em></strong>” ile sağlığınızda güvence altında!',
              subList: null
            },
            { paragraph: '3S Sağlık Sistemi', subList: null },
            {
              paragraph:
                'Mapfre Özel Sağlık sigortası kapsamında sunulan 2 plan vardır: ',
              subList: [
                'Limitsiz Yatarak Teminatı',
                'Limitsiz Yatarak + Ayakta Teminatı'
              ]
            },
            {
              paragraph:
                'Her bütçeye uygun prim ve teminat kapsamı sunan Mapfre Sigorta güvencesi ile sağlık sigortanızı hemen satın alabilir, geniş kapsamlı avantajlarından yararlanabilirsiniz.',
              subList: null
            }
          ]
        },
        {
          title: 'Mapfre Sigorta Tamamlayıcı Sağlık Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Mapfre Tamamlayıcı Sağlık Sigortası kapsamında sunulan “Fark Yok Sigortası” SGK kapsamında anlaşmalı olan özel hastanelerden hizmet alarak fark ücreti ödenmeyen sigorta ürünüdür. Poliçeye eklenen teminatlar özel hastane de yapacağınız harcamaları ve sağlığınızı güvence altına alır.',
              subList: null
            },
            {
              paragraph:
                '<strong><em><u>Yatarak Tedavi Teminatı:</u></em></strong>',
              subList: null
            },
            {
              paragraph:
                'Yatarak tedavi teminatı ile karşılanacak durumdan sigorta poliçenizin başlangıcından sonra ortaya çıkan durumları kapsar.',
              subList: null
            },
            {
              paragraph: 'Yatarak Tedavi Teminatı:',
              subList: [
                'Dâhili ya da cerrahi yatışlar, ',
                'Sigortalının hayati bir tehlikeye neden olabilecek acil sağlık durum giderleri,',
                'Küçük müdahaleler karşılanır.'
              ]
            },
            {
              paragraph:
                '<strong><em><u>Ayakta Tedavi Teminatı:</u></em></strong>',
              subList: null
            },
            {
              paragraph:
                'Sigorta başlangıç tarihinden sonra gerçekleşen rahatsızlıklara ilişkin yapılacak işlemler karşılanır.',
              subList: null
            },
            {
              paragraph: 'Ayakta tedavi teminatı ile karşılanacak durumlar;',
              subList: [
                'Doktor muayene,',
                'Tahlil, radyoloji,',
                'Modern teşhis yöntemleri,',
                'Fizik tedavi,',
                'Rehabilitasyon giderleridir'
              ]
            },
            {
              paragraph:
                'Ayakta Tedavi Teminatını poliçesine alan sigortalılar yapılacak işlemleri poliçe limitleri doğrultusunda karşılatabilir.',
              subList: null
            },
            {
              paragraph:
                '*** İlaç ve aşı giderleri poliçe kapsamında değerlendirilmemektedir.',
              subList: null
            }
          ]
        },
        {
          title: 'Mapfre Sigorta Seyahat Sağlık Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Mapfre Seyahat Sağlık Sigortası hem yurtiçi hem de yurt dışı seyahatlerinizi güvence altına alır. Planlamış olduğunuz iş gezilerini ya da tatil planlarınızı olası risklere karşı güvence altına almanız olukça kolaydır.',
              subList: null
            },
            {
              paragraph:
                '<strong><em><u>Mapfre Seyahat Sağlık Sigortası Planları:</u></em></strong>',
              subList: [
                'Keyif Yurt Dışı Seyahat Sigortası',
                'Vize Yurt Dışı Seyahat Sigortası',
                'Yurt Dışı Eğitim ve Sağlık Sigortası (YESS)',
                'Yurt İçi Seyahat Sağlık Sigortası'
              ]
            },
            {
              paragraph:
                'Seyahat programınızı oluşturmanız durumunda <strong>gideceğiniz yeri</strong> ve <strong><em>tarihleri</em></strong> sigorta uzmanlarımıza iletmeniz sonucunda en uygun Mapfre Sigorta fiyatını sizlere sunuyor olacağız.',
              subList: null
            }
          ]
        },
        {
          title: 'Mapfre Sigorta Poliçe Sorgulama Nasıl Yapılır?',
          content: [
            {
              paragraph:
                'Mapfre Sigorta Online İşlemler Menüsü sayesinde poliçe sorgulama işlemlerinizi kolayca gerçekleştirebilirsiniz.',
              subList: null
            },
            {
              paragraph:
                'Mapfre Sigorta’nın resmi web sitesini ziyaret ederek “<strong><em><u>Bireysel Online İşlemler</u></em></strong>” menüsüne giriş yapmanız gerekmektedir. Bu alanda sizden E-Mail/TCKN ve Şifre istenecektir. Hesabınız yoksa ekrandan yeni hesap oluşturarak devam edebilirsiniz.',
              subList: null
            },
            {
              paragraph:
                'Sigorta poliçelerini <strong><em><u>AloKasko</u></em></strong> uzmanlarından satın alan sigortalılarımız, sigorta danışmanlarını <strong><em><u>0216 371 67 77</u></em></strong> iletişim numarasından arayarak, sorgulama yaptırabilir.',
              subList: null
            }
          ]
        },
        {
          title: 'Mapfre Sigorta Hasar Dosya Sorgulama Nasıl Yapılır?',
          content: [
            {
              paragraph:
                'Mapfre Sigorta Hasar Dosya Sorgulaması yapmak için <strong><em><u>Mapfre Hasar İhbar Portalına</u></em></strong> giriş yapmanız gerekmektedir. Bu alana sigorta şirketinin resmi web sitesinden online işlemler menüsünden ulaşabilirsiniz.',
              subList: null
            },
            {
              paragraph:
                '<strong><em><u>Mapfre Hasar İhbar Portalından İşlem Yapmak İçin Aşağıdaki Maddelerden En Az Bir Maddeyi Bilmenize İhtiyacınız Vardır:</u></em></strong>',
              subList: [
                'Hasar Dosya No Ve Poliçe No',
                'Hasar Dosya No Ve Plaka',
                'Sigortalı T.C. Kimlik No/Vergi Kimlik No Ve Poliçe No'
              ]
            },
            {
              paragraph:
                'Bu adımlardan birini seçenek giriş yapabilir ve sorgulama işleminizi gerçekleştirebilirsiniz.',
              subList: null
            },
            {
              paragraph:
                'Sigorta poliçesini <strong><em><u>AloKasko</u></em></strong> uzmanlarından satın alan sigortalılarımızın tüm hasar işlemleri tarafımızdan takip edilmektedir. Hasar dosyanız hakkında bilgi almak için sigorta danışmanınıza <strong><em><u>0216 371 67 77</u></em></strong> iletişim numarasını arayarak bağlanabilirsiniz.',
              subList: null
            }
          ]
        },
        {
          title: 'Mapfre Sigorta Poliçe Fiyatı Nasıl Alınır?',
          content: [
            {
              paragraph:
                'Mapfre Sigorta ürünlerinden faydalanmak isteyen tüm adaylar teklif formunu doldurarak fiyat karşılaştırması yapabilir.',
              subList: null
            },
            {
              paragraph:
                'Anlaşmalı sigorta şirketimiz olan Mapfre Sigorta’nın en güncel teminatlarını ve en uygun poliçe fiyatlarını size sunuyor olacağız. Merak ettiğiniz tüm sorularınızı AloKasko Sigorta Danışmanlarına sorabilirisiniz.',
              subList: null
            }
          ]
        }
      ]
    }
  }
}
</script>
